import { RawPreference, Preference } from './Interface';

export const PreferencesFactory = (preferences: RawPreference[]) => {
  return preferences.map(preference => {
    return {
      severity: preference.severity,
      name: preference.name,
      type: preference.alert_type,
      group: preference.group,
      description: preference.description,
      configs: {
        email: preference.alert_channel_preference.email_enabled
      }
    };
  });
};

export const RawPreferencesFactory = (preferences: Preference[]): RawPreference[] => {
  return preferences.map(preference => {
    return {
      severity: preference.severity,
      name: preference.name,
      alert_type: preference.type,
      group: preference.group,
      description: preference.description,
      alert_channel_preference: {
        email_enabled: preference.configs.email
      }
    };
  });
};
